import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5ce59a6a&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=5ce59a6a&lang=css"
import style1 from "./Pay.vue?vue&type=style&index=1&id=5ce59a6a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce59a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce59a6a')) {
      api.createRecord('5ce59a6a', component.options)
    } else {
      api.reload('5ce59a6a', component.options)
    }
    module.hot.accept("./Pay.vue?vue&type=template&id=5ce59a6a&scoped=true", function () {
      api.rerender('5ce59a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThirdPay/Pay.vue"
export default component.exports